import { ResourceAction, ResourceActionType, ResourceFiltersValues, ResourceState } from './types';

export const getResourceFiltersInitialState = (): ResourceFiltersValues => ({
  filters: {},
  activeFilter: null,
  selectedFilters: [],
  resources: [],
  resourcesSearchText: '',
  filteredResources: [],
  pinnedResources: [],
  pinActions: { amount: 0 },
});

export const resourceFiltersReducer = (state: ResourceState, action: ResourceAction) => {
  switch (action.type) {
    case ResourceActionType.SET_FILTERS:
      return {
        ...state,
        ...{
          filters: action.payload.reduce(
            (acc, current) => ({
              ...acc,
              [current.name?.toLocaleLowerCase().replace(' ', '_') as string]: {
                ...current,
              },
            }),
            {}
          ),
        },
      };
    case ResourceActionType.SET_RESOURCES:
      return { ...state, ...{ resources: action.payload } };
    case ResourceActionType.REMOVE_RESOURCE:
      return {
        ...state,
        ...{ resources: state.resources.filter((_resource) => _resource.id !== action.payload.id) },
      };
    case ResourceActionType.REMOVE_ALL_FILTERS:
      return { ...state, ...{ selectedFilters: [], resourcesSearchText: '' } };
    case ResourceActionType.SET_SELECTED_FILTER:
      return { ...state, selectedFilters: action.payload };
    case ResourceActionType.SET_RESOURCES_SEARCH_TEXT:
      return { ...state, ...{ resourcesSearchText: action.payload } };
    case ResourceActionType.SET_PINNED_RESOURCES:
      return { ...state, ...{ pinnedResources: action.payload } };
    case ResourceActionType.ADD_PINNED_RESOURCE:
      return {
        ...state,
        ...{ pinnedResources: [...state.pinnedResources, action.payload] },
      };
    case ResourceActionType.REMOVE_PINNED_RESOURCE:
      return {
        ...state,
        ...{
          pinnedResources: state.pinnedResources.filter(
            (_resource) => _resource.id !== action.payload
          ),
        },
      };
    case ResourceActionType.SET_PIN_ACTIONS:
      return {
        ...state,
        ...{
          pinActions: {
            amount:
              action.payload === 'PINNING'
                ? state.pinActions.amount + 1
                : state.pinActions.amount - 1,
          },
        },
      };
    default:
      return state;
  }
};
